module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/map/location-arrow-2d9a10891b95e2bd19321a06587491ec.svg";